import { render, staticRenderFns } from "./SQuesFortySix.vue?vue&type=template&id=223c49cc&"
import script from "./SQuesFortySix.vue?vue&type=script&lang=js&"
export * from "./SQuesFortySix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports